import get from 'transmute/get';
import { TEXT, STATUS } from '../constants/keyPaths';
export const getEmailCapturePromptText = get(TEXT);
export const getText = message => {
  return getEmailCapturePromptText(message);
};
export const getStatus = get(STATUS);